<template>
  <div :class="{'container-ingressos': desktop, 'w-100': mobile}">
    <p class="text-h6 primary--text pa-5 mb-0">
      Ingressos disponiveis
    </p>

    <div class="scroll-ingressos">
      <div
        v-for="ingresso in ingressos"
        :key="ingresso.number"
        class="tab-ingresso d-flex flex-row justify-space-between px-5 py-2"
        :class="{'active': ingressoAtual == ingresso.number, 'inactive': ingresso.id}"
        @click="ingresso.id ? detalheIngresso(ingresso) : selecionaIngresso(ingresso)"
      >
        <div class="label-ingresso">
          {{ ingresso.id ? ingresso.name : 'Ingresso ' + ingresso.number }}
        </div>

        <v-chip :color="ingresso.id ? 'green' : 'blue'" class="white--text">
          {{ ingresso.id ? 'Dados preenchidos' : 'Vazio' }}
        </v-chip>
      </div>
    </div>

    <v-btn
      v-if="mobile"
      class="mt-2 my-5"
      color="primary"
      text
      block
      @click="$emit('change', ingressoAtual)"
    >
      Prosseguir <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</template>

<script>

export default {
  name: 'TitularidadeIngressoTabs',

  props: {
    ingressos: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    ingressoAtual: null,
    ingressoSelecionado: null,
  }),

  watch: {
    ingressoAtual(value) {
      if (this.desktop) {
        this.$emit('change', value);
      }
    },
  },

  async mounted() {
    if (this.desktop) {
      const primeiroIngressoVazio = this.ingressos.find(ingresso => ingresso.id == null);

      if (primeiroIngressoVazio) {
        this.selecionaIngresso(primeiroIngressoVazio);
      }
    }
  },

  methods: {
    selecionaIngresso(ingresso) {
      if (ingresso.id) {
        return;
      }

      this.ingressoAtual = ingresso.number;

      this.$nextTick(() => {
        document.querySelector('.tab-ingresso.active').scrollIntoView();
      });
    },

    detalheIngresso(ingresso) {
      this.ingressoAtual = ingresso.number;
      this.ingressoSelecionado = ingresso;
    },
  },
};
</script>

<style scoped>
.container-ingressos {
  width: 420px;
  border-right: solid #D3D4D3 1px;
}

.scroll-ingressos {
  max-height: 408px;
  overflow-y: auto;
}

.tab-ingresso {
  background-color: #FFF;
  width: 100%;
  text-transform: none;
  border-bottom: solid #D3D4D3 1px;
  border-top: solid #D3D4D3 1px;
  cursor: pointer;
}

.tab-ingresso:not(.active, .inactive):hover {
  background-color: #F0F0FF;
}

.tab-ingresso ~ .tab-ingresso {
  border-top: none;
}

.tab-ingresso.active {
  background-color: #DDF;
  font-weight: bold;
  cursor: default;
}

.label-ingresso {
  max-width: 138px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
